// removed by extract-text-webpack-plugin
module.exports = {"container":"medium-more-tooltip__container__2Eg68","row":"medium-more-tooltip__row__3jHIP","flag-icon":"medium-more-tooltip__flag-icon__2Hhz7","delete-icon":"medium-more-tooltip__delete-icon__2U64G"};


//////////////////
// WEBPACK FOOTER
// ./src/components/media/medium-more-tooltip.scss
// module id = 1446
// module chunks = 1